<app-file-upload
    [whiteListFile]="filesAccepted"
    [subtitle]="fieldData.subLabel || ''"
    [title]="fieldData.label || ''"
    (filesAdded)="filesAdded($event)"
    [loading]="uploading"
    [tooltipMessage]="fieldData.tooltipMessage || ''"
    [isDisabled]="fieldData.isDisabled || false"
/>
<div class="mt-2">
    <app-file-remover />
</div>
<app-dynamic-error [field]="fieldData" />
